import findIndex from "lodash-es/findIndex";
import map from "lodash-es/map";

export default {
  props: {
    company: { type: Object },
  },

  data: () => ({
    items: [],
    resourceBase: "",
    creating: false,
  }),

  created() {
    this.loadList();
  },

  methods: {
    loadList() {
      const promise = this.$http
        .get(this.resourceBase, {
          params: {
            per_page: 999,
            context: "list",
          },
        })
        .then((response) => {
          this.items = response.data.data;
          this.syncIds();
        });

      this.withUiBlocker(promise, this.$el);
    },

    edit(item) {
      item.editing = true;
      this.$forceUpdate();
    },

    finishSave(item = null, reload = false) {
      this.creating = false;

      if (item) {
        item.editing = false;
      }
      this.$forceUpdate();

      if (reload) {
        this.loadList();
      }
    },

    remove(item) {
      const promise = this.$http
        .delete(`${this.resourceBase}/${item.id}`)
        .then(() => {
          let index = findIndex(this.items, (item) => item === item);
          this.items.splice(index, 1);
          this.syncIds();
        });

      return this.withUiBlocker(promise, this.$el);
    },

    syncIds() {
      this.fieldValue = map(this.items, "id");
    },
  },
};
